import { useQueryClient } from 'react-query'
import { KEYS } from 'features/workflows/constants'

export function useInvalidateWorkflowsList() {
  const queryClient = useQueryClient()
  const invalidateWorkflowsList = () => queryClient.invalidateQueries(KEYS.workflows, { exact: false })
  return { invalidateWorkflowsList }
}
